import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

import { CONTRACT_CONTACTS_ENDPOINT } from "./endpoints";
import { contractContactsQueryKey } from "./query-keys";

/**
 * Removes a contact from the contract by destroying every subscription it holds
 * here.
 *
 * One request per row — the resource is a plain `apiResource`, so there is no
 * way to batch them. They go out together and the first rejection fails the
 * mutation; the refetch that follows shows whatever actually survived, so the
 * table never claims a row is gone when it isn't.
 *
 * The `contacts` record itself is untouched: it may be attached to other
 * contracts, and this action is about this contract's alerts.
 */
export const useDeleteOccupantService = (contractId: string | number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (contractContactIds: string[]) => {
      await Promise.all(
        contractContactIds.map((id) => axiosInstance().delete(`${CONTRACT_CONTACTS_ENDPOINT}/${id}`)),
      );
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: contractContactsQueryKey(String(contractId)) });
    },
  });
};
